import React from "react";
import { Button } from "@mui/material";

interface MisdeliveryFormActionsProps {
  onClear: () => void;
  onSubmit: () => void;
  onF18Note?: () => void;
  isSubmitting?: boolean;
  formMode?: string;
  showF18NoteButton?: boolean;
}

const MisdeliveryFormActions: React.FC<MisdeliveryFormActionsProps> = ({
  onClear,
  onSubmit,
  onF18Note,
  isSubmitting = false,
  formMode = "entry",
  showF18NoteButton = false,
}) => {
  // Button logic based on formMode
  // entry: show Submit, Clear, F18 Note
  // f18Note: show Enter F18 Note, Clear (clear only resets f18 fields)
  // view: show Edit button only
  // edit: show Update (disabled), Cancel (disabled)

  return (
    <div className="btn-group-submit">
      {formMode === "entry" && (
        <>
          <Button
            type="button"
            variant="contained"
            className="clear-btn mr-0 ml"
            onClick={() => {
              document?.getElementsByName("hasProNumber")?.[0]?.focus();
              onClear()
            }
            }
            disabled={isSubmitting}
          >
            Clear
          </Button>
          <Button
            type="submit"
            variant="contained"
            className="entry ml"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </>
      )}
     
      {showF18NoteButton && (
        <Button
          type="button"
          variant="contained"
          className="assign mr-0 ml"
          onClick={onF18Note}
        >
         Add F18 Note
        </Button>
      )}
    </div>
  );
};

export default MisdeliveryFormActions;
